module.exports = __webpack_public_path__ + "static/sport/mb-bgi.0ac68d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mb-bgi.png
// module id = IXwQ
// module chunks = 0